export class ClientDocumentModel {
  id: number;
  type:
    | 'DRIVERS_LICENSE_FRONT'
    | 'DRIVERS_LICENSE_BACK'
    | 'ID_CARD_FRONT'
    | 'ID_CARD_BACK'
    | 'PASSPORT'
    | 'INSURANCE'
    | 'OTHER';
  asset: ClientDocumentAssetModel;
}

export class ClientDocumentAssetModel {
  id: number;
  mainAsset: ClientDocumentMainAssetModel;
  attachments: ClientDocumentAttachmentModel;
}

export class ClientDocumentMainAssetModel {
  id: number;
  contentType: string;
  downloadUrl: string;
  filename: string;
  filesize: number;
}

export class ClientDocumentAttachmentModel {
  id: number;
  contentType: string;
  downloadUrl: string;
  filename: string;
  filesize: number;
}
